export default "__VITE_ASSET__ba218a2b__"